import { create } from 'zustand'
import type {
  DictionaryKey,
  ServeConfigModel,
  ServeDictionaryModel
} from 'api/base-model'
import { getConfig } from 'api'
import { CheckboxGroupProps } from "antd/es/checkbox"

interface ServeConfigStoreModel {
  dictionary: ServeConfigModel['dictionary'] | null

  fetchData(): Promise<void>

  getDictionary(
    key: DictionaryKey,
    exclude?: (number | string)[]
  ): ServeDictionaryModel[]

  getDictionaryLabel(key: DictionaryKey, value: number): ServeDictionaryModel | undefined,
  getDictionaryLabelValue(key: DictionaryKey,lang:string,exclude?: (number | string)[]):CheckboxGroupProps<string>['options']
}

export default create<ServeConfigStoreModel>()((set, get) => ({
  dictionary: null,
  async fetchData() {
    const res = await getConfig()

    set({ dictionary: res.data.dictionary })
  },
  getDictionary(key, exclude = []) {
    return (
      get().dictionary?.[key].filter(
        (item) => !exclude.includes(item.value!)
      ) ?? []
    )
  },
  getDictionaryLabel(key, value) {
    const dictionary = get().getDictionary(key)
    const item = dictionary.find((item) => item.value === value)
    return item
  },
  getDictionaryLabelValue(key,lang, exclude = []) {
    const data = get().dictionary?.[key].filter((item) => !exclude.includes(item.value!)) ?? [];

    let tempData:CheckboxGroupProps['options'] = [];

    for (let index = 0; index < data.length; index++) {
      const element = data[index];

      let name: string | undefined = "";

      if (lang == "zh-CN") {
        name = element?.labelZh!;
      }
      else {
        name = element?.labelEn!;
      }

      tempData.push({ label: name, value: element.value });
    }

    return tempData;
  },
}))
